<template lang="pug">
.teams-card-table
  card-table(:total-items='data.length' breakpoint-size='lg')
    template(v-for='(item, index) in data' v-slot:[`card-${index}`]='{}')
      .mb-1 {{ $t('teamsCardTable.name') }}: {{ item.name }}
      .mb-1 {{ $t('teamsCardTable.users') }}: {{ item.users.length }}
      .mb-0
        button.btn-view-team(
          :title='$t("teamsCardTable.view")'
          @click.stop='openViewTeamUsers(item, $event)'
          v-tooltip:bottom='$t("teamsCardTable.view")'
        )
          icon(name='users')
        button.btn-edit-team(
          :title='$t("teamsCardTable.use")'
          @click.stop='openEditTeamModal(item)'
          v-if='isOwner'
        )
          icon(name='pen-to-square')
    template(v-slot:table-head)
      th(style='width: 50%') {{ $t('teamsCardTable.name') }}
      th(style='width: 40%') {{ $t('teamsCardTable.users') }}
      th(style='width: 6%')
    template(v-for='(item, index) in data' v-slot:[`table-row-${index}`]='{}')
      td {{ item.name }}
      td {{ item.users.length }}
      td
        .text-end.d-flex
          button(
            :title='$t("teamsCardTable.view")'
            @click.stop='openViewTeamUsers(item, $event)'
            v-tooltip:bottom='$t("teamsCardTable.view")'
          )
            icon(name='users')
          button(
            :title='$t("teamsCardTable.use")'
            @click.stop='openEditTeamModal(item)'
            v-if='isOwner'
          )
            icon(name='pen-to-square')
  edit-team-modal(
    :team='this.selectedTeam'
    :title='this.selectedTeam.name'
    @item-deleted='$emit("item-deleted")'
    @refresh='$emit("item-edited")'
    ref='editTeamModal'
  )
</template>

<script>
import Icon from '@/ui/atoms/Icon.vue';
import CardTable from '@/ui/organisms/CardTable.vue';
import EditTeamModal from '@/modules/account/components/organisms/modals/EditTeamModal.vue';

export default {
  name: 'TeamsCardTable',
  components: {
    Icon,
    CardTable,
    EditTeamModal,
  },
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      selectedTeam: {},
    };
  },
  computed: {
    isOwner() {
      return this.$store.state.organizations.selected?.is_owner;
    },
  },
  filters: {},
  methods: {
    openViewTeamUsers(team, event) {
      if (event) {
        window.jQuery(event.currentTarget).tooltip('dispose');
      }
      this.$router.push({
        name: 'account.teams.users',
        params: { teamId: team.id },
      });
    },
    openEditTeamModal(team) {
      this.selectedTeam = team;
      this.$nextTick(this.$refs.editTeamModal.$refs.modal.open);
    },
  },
};
</script>

<style lang="stylus">
.teams-card-table
  .btn-view-team
    position: absolute
    top: 0.5rem
    right: 2.5rem
  .btn-edit-team
    position: absolute
    top: 0.5rem
    right: 0.45rem
</style>
